import { gql } from "@apollo/client";

// Only what the update page reads. rejectionErrors is derived from the LATEST version — the page's
// signal that the last update failed.
export const getWebLensForUpdate = gql`
    query getWebLensForUpdate($lensId: ID!) {
        getLens(input: { lensId: $lensId }) {
            lens {
                id
                name
                status
                iconUrl
                isGameUserProvided
                visibility
                lensAccountId {
                    lensSpaceId
                }
                exclusiveLensStatus
                lensCreatorPayoutEligibility
                distributionsList {
                    destinationId
                    destinationType
                    status
                }
                rejectionErrors {
                    hasSubmissionErrors
                }
                # The whole media shape, not just the two fields the converter reads:
                # convertMyLensesPreviewMediaToItems takes MyLensesPreviewMedia, and a narrower
                # selection would not satisfy it.
                previewMediaList {
                    mediaId
                    standardMediaUrl
                    standardMediaPosterUrl
                    thumbnailMediaUrl
                    thumbnailMediaPosterUrl
                }
            }
        }
    }
`;
